import { render, staticRenderFns } from "./FilesEnglish.vue?vue&type=template&id=f920ff36"
import script from "./FilesEnglish.vue?vue&type=script&lang=js"
export * from "./FilesEnglish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports